export interface ParameterConfig {
  // 智能体启动设置 0:文字 1:图片
  input_parameter_type: number;
}

export enum ItemType {
  /** 智能体启动设置 */
  InputParameter = 17,
}